import { Accessor, createEffect } from "solid-js";
import { useDropdownContext } from "./DropdownContext";

declare module "solid-js" {
    namespace JSX {
        interface Directives {
            focused: boolean;
            defaultInput: () => void
        }
    }
}

declare global {
    interface Window {
        focused: (el: HTMLInputElement, params: Accessor<boolean>) => void;
        defaultInput: (el: HTMLInputElement, params: Accessor<() => void>) => void;
    }
}

window.focused = window.focused ?? ((el: HTMLInputElement, params: Accessor<boolean>) => {
    createEffect(() => {
        const dropdownCtx = useDropdownContext();
        const isFocused = params();

        if (dropdownCtx?.isOpen() || !dropdownCtx) {
            if (isFocused) {
                requestAnimationFrame(() => el.focus());
            }
        }
    });
});

window.defaultInput = window.defaultInput ?? ((el: HTMLInputElement, params: Accessor<undefined | (() => void)>) => {
    const dropdownCtx = useDropdownContext();
    const callback = params();

    if (callback) {
        el.addEventListener('keypress', (ev: KeyboardEvent) => {
            if (ev.key === 'Enter') {
                callback();
                dropdownCtx?.setIsOpen(false);
            }
        });
    }
});
